import { useFormik } from 'formik';
import * as yup from 'yup';
import { useSnackbar } from 'notistack';
import { Button, Dialog, DialogActions, DialogContent, DialogProps, DialogTitle, Grid, TextField } from '@mui/material';

import { Region } from '@/types';
import { useUpdateRegionMutation } from '@/services';
import { messages } from '@/utils/helpers';

export interface UpdateRegionProps extends DialogProps {
  region: Region;
  onClose(): void;
}

const UpdateRegion: React.FC<UpdateRegionProps> = ({ region, onClose, ...props }) => {
  const { enqueueSnackbar } = useSnackbar();

  const [updateRegion, updateRegionResponse] = useUpdateRegionMutation();

  const { values, errors, touched, handleSubmit, handleChange } = useFormik<Region>({
    initialValues: region ?? {
      name: '',
    },
    enableReinitialize: true,
    validationSchema: yup.object().shape({
      name: yup.string().required(messages.form.REQUIRED),
    }),
    async onSubmit(region, { resetForm }) {
      try {
        await updateRegion(region).unwrap();

        onClose();
        resetForm();
      } catch (error) {
        enqueueSnackbar(error.data, { variant: 'error' });
      }
    },
  });

  return (
    <Dialog fullWidth {...props}>
      <DialogTitle fontWeight="bold">Редактировать область</DialogTitle>

      <form onSubmit={handleSubmit}>
        <DialogContent dividers>
          <Grid container spacing={3}>
            <Grid item lg={6} md={6} xs={12}>
              <TextField
                name="name"
                label="Наименование"
                placeholder="Введите значение"
                value={values.name}
                onChange={handleChange}
                disabled={updateRegionResponse.isLoading}
                error={touched.name && Boolean(errors.name)}
                helperText={touched.name ? errors.name : ''}
                fullWidth
              />
            </Grid>
          </Grid>
        </DialogContent>

        <DialogActions>
          <Button
            type="button"
            color="secondary"
            variant="outlined"
            disabled={updateRegionResponse.isLoading}
            onClick={onClose}
          >
            Закрыть
          </Button>

          <Button type="submit" variant="contained" disabled={updateRegionResponse.isLoading}>
            Редактировать
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default UpdateRegion;
